export enum MenuItem {
	REGISTER = 'REGISTER',
	LAB_REGISTER = 'LAB_REGISTER',
	DENTIST_REGISTER = 'DENTIST_REGISTER',
	LOGIN = 'LOGIN',
	FORGOT_USERNAME = 'FORGOT_USERNAME',
	FORGOT_PASSWORD = 'FORGOT_PASSWORD',
	RESET_PASSWORD = 'RESET_PASSWORD',
	WELCOME = 'WELCOME',
	MY_USER = 'MY_USER',
	MY_USER_DATA = 'MY_USER_DATA',
	CHANGE_PASSWORD = 'CHANGE_PASSWORD',
	MY_COMPANY = 'MY_COMPANY',
	MY_COMPANY_DATA = 'MY_COMPANY_DATA',
	MY_BILLING_SHIPPING_ADDRESS = 'MY_BILLING_SHIPPING_ADDRESS',
	LAB_PROFILE = 'LAB_PROFILE',
	ADDITIONAL_ORDER_INFORMATION = 'ADDITIONAL_ORDER_INFORMATION',
	DISABLE_ACCOUNT = 'DISABLE_ACCOUNT',
	PARTNER = 'PARTNER',
	MY_FAVOURITE_TRANSMITTER = 'MY_FAVOURITE_TRANSMITTER',
	MY_FAVOURITE_RECIPIENTS = 'MY_FAVOURITE_RECIPIENTS',
	CONNECT_DIRECT = 'CONNECT_DIRECT',
	LINKED_PORTALS = 'LINKED_PORTALS',
	ORDER_LIST = 'ORDER_LIST',
	RECEIVED_ORDERS = 'RECEIVED_ORDERS',
	SEND_ORDERS = 'SEND_ORDERS',
	USER_ADMINISTRATION = 'USER_ADMINISTRATION',
	USER_LIST = 'USER_LIST',
	CONNECT_CASE_CENTER_INBOX = 'CONNECT_CASE_CENTER_INBOX',
	CONNECT_INBOX_WORKSTATIONS = 'CONNECT_INBOX_WORKSTATIONS'
}
